import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useRef, useState } from "react";

import { IInventoryManufacturerCreateProps } from "@/api_framework/api_modals/Inventory";
import ToggleWithIcon from "@/app/components/ui/Toggles/ToggleWithIcon";
import { useInventoryManufacturereDetailsAPI } from "@/app/hooks/api_hooks/Inventory/useInventoryManufacturereDetailsAPI";
import { useInventoryManufacturereListAPI } from "@/app/hooks/api_hooks/Inventory/useInventoryManufacturereListAPI";
import { useInventoryManufacturereUpdateAPI } from "@/app/hooks/api_hooks/Inventory/useInventoryManufacturereUpdateAPI";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { IInventoryState, setManufacturerDetails } from "@/app_redux/reducers/slices/auth/inventory_slice";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useDispatch } from "react-redux";
import clsx from "clsx";
import { PRIMARY_BUTTON, SECONDARY_BUTTON } from "@/constants";

const ManufacturerActiveDeactiveComponent = (props) => {
  const cancelButtonRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [openFlage, setOpenFlage] = useState(props?.flage);

  const { getRouteKey } = useRouter();
  const routeId = getRouteKey("INVENTORY", "id");
  const { routeState } = useRouteInfo(routeId);
  const dispatch = useDispatch();

  const { manufacturerDetails } = routeState.state as IInventoryState;

  const updateManufacturere = useInventoryManufacturereUpdateAPI();
  const fetchManufacturereDetails = useInventoryManufacturereDetailsAPI();
  const fetchBatchListAPI = useInventoryManufacturereListAPI();

  const handelClick = () => {
    const constructedBody: IInventoryManufacturerCreateProps = {
      manufacturer_name: manufacturerDetails?.manufacturer_name,
      origin_country: manufacturerDetails?.origin_country,
      contact_person_details: manufacturerDetails?.contact_person_details,
      importer_contact_details: manufacturerDetails?.importer_contact_details,
      status: manufacturerDetails?.status ? false : true,
    };
    updateManufacturere(constructedBody, props?.manufacturer_id).then(() => {
      setOpen(false);
      fetchBatchListAPI();
    });
  };

  const handelToggle = () => {
    setOpen(false);
    setOpenFlage(props?.flage);
  };

  useEffect(() => {
    setOpenFlage(props?.flage);
  }, [props?.flage]);

  useEffect(() => {
    if (open) {
      fetchManufacturereDetails(props?.manufacturer_id);
    } else {
      dispatch(setManufacturerDetails({ data: null }));
    }
  }, [open]);

  return (
    <div>
      <div className="">
        <ToggleWithIcon
          toggleState={openFlage}
          forced
          onToggleChange={() => {
            setOpen(!open);
          }}
        />
      </div>

      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          initialFocus={cancelButtonRef}
          onClose={() => setOpen(false)}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>

            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block  align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full sm:max-w-xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <span className="flex justify-end ml-6 cursor-pointer" onClick={() => setOpen(false)}>
                    <XMarkIcon className="h-5 w-5" />
                  </span>
                  <h3 className="text-sm text-[#000] font-medium mb-1 flex justify-between">
                    {`Are you sure you want to ${props?.flage ? "deactivate" : "activate"} manufacturer type ?`}
                  </h3>
                  <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mt-6 sm:justify-end">
                    <button
                      type="button"
                      onClick={() => handelToggle()}
                      className={clsx(SECONDARY_BUTTON, "w-full sm:w-auto")}
                    >
                      No
                    </button>
                    <button
                      type="button"
                      onClick={() => handelClick()}
                      className={clsx(PRIMARY_BUTTON, "w-full sm:w-auto")}
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default ManufacturerActiveDeactiveComponent;
